import { useQuery } from "@tanstack/react-query";
import { endpoints } from "../endpoints/endpoints";
import axiosInstance from "../utilites/axios";
import moment from "moment-timezone";

export const useGetQuickListList = ({ limit, startDate, endDate }) => {
  return useQuery({
    queryKey: ["screeningList", limit, startDate, endDate],
    queryFn: async () => {
      return await axiosInstance
        .get(
          `${endpoints.quickList}?limit=100&startDate=${startDate}&endDate=${endDate}`
        )
        .then((res) => {
          if (res?.status === 200) {
            return res?.data;
          } else {
            return [];
          }
        })
        .catch((e) => {
          // console.log("error", e);
        });
    },
    refetchInterval: 500 * 10,
    onSuccess: ({ data }) => {
      return data;
    },
  });
};

export const useGetQuickListDetails = ({ uid, startDate, endDate }) => {
  return useQuery({
    queryKey: ["screeningDetails", uid, startDate, endDate],
    queryFn: async () => {
      return await axiosInstance
        .get(
          `${endpoints.quickList}/details?uid=${uid}&startDate=${startDate}&endDate=${endDate}`
        )
        .then((res) => {
          if (res?.status === 200) {
            return res?.data;
          } else {
            return [];
          }
        })
        .catch((e) => {
           console.log(e);
        });
    },
    refetchInterval: 500 * 10,
    onSuccess: ({ data }) => {
      return data;
    },
  });
};
